module.exports = __webpack_public_path__ + "static/img/Jaipur_Cinema-1.4e0f620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsImages/Jaipur_Cinema-1.jpg
// module id = 4DpI
// module chunks = 11